<template>
  <div>
    <div class="mt-2">
      <v-btn icon :to="{ name: 'diario-escolar-aulas', params: { ano, cdturma, disciplina, tipoDeEnsino, cdinstruc, AEEouACP, pagina } }">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>
    <grafico :alunos="alunos" />
    <div>
      <hr>
      <h3>Legendas</h3>
      <ul class="legendas">
        <li v-for="(texto, cor) in legendas" :key="cor" class="legenda">
          <div class="cor-legenda" :style="{ backgroundColor: cor }"></div> {{texto}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import store from '@/store/index';
import diarioEscolarRepository from '@/repositories/diarioEscolarRepository';
import grafico from '@/components/charts/GraficoAusencia';
import _ from 'lodash';

const dadosUser = () => ({
  ...store.getters.school,
});

export default {
  name: 'GraficoAusencia',
  components: {
    grafico
  },
  async created(){
    const {ano, cdturma, disciplina} = this.$route.params;

    if(typeof ano === 'undefined' || typeof cdturma === 'undefined' || typeof disciplina === 'undefined'){
      return this.$router.push('/diario-escolar');
    }

    const { cdtipesc, cdescola } = dadosUser();
    const { data } = await diarioEscolarRepository.getGraficoAusencia({
      cdtipesc,
      cdescola,
      aaletivo: ano,
      cdturma: cdturma,
      cddiscipl: disciplina,
    });
    this.alunos = _.orderBy(data, ['nome'], ['asc']);
  },
  props: {
    ano: [String, Number],
    cdturma: [String, Number],
    disciplina: [String, Number],
    aulas: Array,
    tipoDeEnsino: [String],
    cdinstruc: [Number],
    pagina: [Number],
    AEEouACP: [Boolean],
  },
  data() {
    return {
      alunos : [],
      legendas: {
        '#DCE775' : 'Faltas totais',
        '#ff9900' : 'A partir de cinco faltas consecutivas',
        '#ff3b00' : 'Próximo a 50 faltas',
        'darkred' : 'Passou de 50 faltas',
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.legendas{
  list-style: none;
  padding: 0;
  .legenda{
    display: flex;
    align-items: center;
    padding: 10px 0;
  }
}

.cor-legenda{
  display: inline-block;
  width: 60px;
  height: 20px;
  border-radius: 5px;
  margin-right: 10px;
  border: 2px solid rgba(0, 0, 0, 0.3);
}
</style>
